import TransactionAllocator from 'components/TransactionAllocator';
import api from 'lib/trpcClient';
import useTransactionTypeSelectorOptions from 'hooks/form/useTransactionTypeSelectorOptions';
import { Row } from 'components/Layout';
import { useBankReconciliationContext } from 'contexts/BankReconciliationContext';
import useVehicle from 'hooks/lp/data/vehicle/useVehicle';
import { FormValues } from './';
import { useFormContext } from 'react-hook-form';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';

type Props = {
  bankAccountOperationId: string;
};

const BankTransferTransactions: React.FC<Props> = ({
  bankAccountOperationId,
}) => {
  const { setValue } = useFormContext<FormValues>();

  const { selectedBankAccount } = useBankReconciliationContext();
  const { vehicle } = useVehicle(selectedBankAccount?.vehicleId);

  const { transactionTypeOptions, isLoading: transactionTypesOptionsLoading } =
    useTransactionTypeSelectorOptions();

  const [{ currencyRate, transactionTypes }] =
    api.bankAccount.getTransferTransactionTypes.useSuspenseQuery({
      vehicleId: selectedBankAccount?.vehicleId ?? '',
      sourceBankAccountId: selectedBankAccount?.id ?? '',
      bankAccountOperationId,
    });

  useEffect(() => {
    setValue('currencyRate', currencyRate ?? undefined);
  }, [currencyRate, setValue]);

  return (
    <Row fullWidth justify="center">
      {transactionTypesOptionsLoading ? (
        <CircularProgress color="inherit" />
      ) : transactionTypes && selectedBankAccount && vehicle ? (
        <TransactionAllocator
          transactions={transactionTypes}
          transactionTypeOptions={transactionTypeOptions}
          onChange={(transactions) => {
            setValue('transactions', transactions);
          }}
          transactionCurrency={selectedBankAccount.accountCurrency}
          vehicle={vehicle}
          fxRate={currencyRate}
        />
      ) : null}
    </Row>
  );
};

export default BankTransferTransactions;
